import React from 'react';

import { LottieSvg } from 'lottie-react';

import styles from './SpinnerLottie.module.css';
import spinnerAnimation from '@/static/lottie/spinner.json';

type SpinnerLottieStyle = React.CSSProperties & Record<'--spinner-lottie-color', string>;

interface SpinnerLottieProps {
    color?: string;
}

export const SpinnerLottie: React.FC<SpinnerLottieProps> = ({ color }) => {
    const style: SpinnerLottieStyle | undefined = color ? { '--spinner-lottie-color': color } : undefined;

    return (
        <div className={styles.spinnerLottieBox} style={style} data-testid="spinner-lottie-div">
            <LottieSvg src={spinnerAnimation} loop autoplay />
        </div>
    );
};
